<template>
    <Card class="layout-card">
        <Tabs v-model="tabIndex" @on-click="changeTab">
            <TabPane :label="summaryTip" name="1">
            </TabPane>
            <TabPane label="短剧报表" name="2">
            </TabPane>
            <TabPane label="优化师剧集" name="3">
            </TabPane>
        </Tabs>
                <KeepAlive :include="['Summary','language','Pitcher']">
                    <Summary v-if="tabIndex == 1 " ref="tableRef" :searchOptions="searchOptions" :flag="flag" :langList="langList" />
                    <Language v-if="tabIndex == 2 " ref="tableRef" :searchOptions="searchOptions" :flag="flag" :langList="langList" />
                    <Pitcher v-if="tabIndex == 3 " ref="tableRef" :searchOptions="searchOptions" :flag="flag" :langList="langList" />
                </KeepAlive>
    </Card>
</template>

<script>
import Summary from './components/summary/index.vue'
import Language from './components/language/index.vue'
import Pitcher from './components/pitcher/index.vue'
import { getCampainInitNew as getCampainInit, getPersonInit, getLang } from '@/api/data'
export default {
    name: 'PlayNewData',
    components:{
        Summary,
        Language,
        Pitcher
    },
    data(){
        return {
            tabIndex: '1',
            flag: 1,
            summaryTip: ()=><Poptip transfer content="指同一部短剧在各语种下的集合" trigger="hover" placement="bottom">
                        <div>
                            中文名称汇总
                        </div>
                    </Poptip>,
            searchOptions: {
                campaign: [],
                person: []
            },
            langList: [],
            extraData: {},
            selectOption: []
        }
    },
    provide(){
        return {
            parent: this
        }
    },
    // watch: {
    //     tabIndex:{
    //         handler(){
    //             this.$nextTick(()=>{
    //                 this.$refs.tableRef.$nextTick(()=>{
    //                     const scroll = document.querySelector(".ivu-table-body");
    //                     const fixed = document.querySelector(".ivu-table-fixed-body");
    //                     console.log(scroll);
                        
    //                     // 监听滚轮
    //                     scroll &&
    //                         scroll.addEventListener(
    //                         "mousewheel",
    //                         (e) => {
    //                             if (scroll.scrollLeft <= 0 && e.deltaX < 0) {
    //                                 e.preventDefault();
    //                             }
    //                         },
    //                         {
    //                             passive: false,
    //                         }
    //                         );
    //                     fixed &&
    //                         fixed.addEventListener("wheel", (e) => {
    //                         e.preventDefault();
    //                         });
    //                 })
    //             })
    //         },
    //         immediate: true
    //     }
    // },
    methods: {
        handleGetDataInit() {
            // getCampainInit({
            //     current: 1,
            //     size: 200
            // }).then(r => {
            //     this.searchOptions.campaign = r.data.records
            // })
            getPersonInit().then(r => {
                this.searchOptions.person = r.data.records
            })
        },
        changeTab(e){
            this.extraData = {}
        },
        handleGetLang(){
            getLang({
                current:1,
                size: 1000,
                langStatus: true
            }).then(r=>{
                this.langList = r.data.records
            })
        }
    },
    created(){
        this.handleGetDataInit()
        this.handleGetLang()
        
        this.flag = localStorage.getItem('user-campaign-flag')?Number(localStorage.getItem('user-campaign-flag')):1
    },
    
}
</script>

<style lang="less" scoped>
.layout-card {
    /deep/ .ivu-card-body {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
}
</style>